import { h, Component, Fragment } from 'preact';
import { Trans } from "@lingui/react/macro";
import { msg } from "@lingui/core/macro";
import FullSite from './full-site';
import { TournamentDetails, LeaderboardEntry, DetailsApiResponse, SlotTournamentsService } from '../../../services/slot-tournaments';
import { TournamentDetailsDisplay } from '../desktop-components/TournamentDetailsDisplay';
import { LeaderboardDisplay } from '../desktop-components/LeaderboardDisplay';

interface TournamentLeaderboardContentProps {
    tournamentId: string;
}

interface TournamentLeaderboardContentState {
    tournament: TournamentDetails | null;
    leaderboard: LeaderboardEntry[];
    loading: boolean;
    error: boolean;
}

export class TournamentLeaderboardContent extends Component<TournamentLeaderboardContentProps, TournamentLeaderboardContentState> {
    state = {
        tournament: null,
        leaderboard: [],
        loading: true,
        error: false,
    }

    private service: SlotTournamentsService = new SlotTournamentsService();

    componentDidMount() {
        if (this.props.tournamentId) {
            this.fetchTournamentData(this.props.tournamentId);
        } else {
            this.setState({ loading: false, error: true });
        }
    }

    async fetchTournamentData(id: string) {
        this.setState({ loading: true, error: false });

        try {
            const numericId = parseInt(id, 10);
            const response: DetailsApiResponse = await this.service.getTournamentDetails(numericId);

            if (response.status === 'success') {
                this.setState({
                    tournament: response.data.tournament,
                    leaderboard: response.data.leaderboard || [],
                    loading: false,
                    error: false,
                });
            } else {
                this.setState({ loading: false, error: true, tournament: null, leaderboard: [] });
            }
        } catch (err) {
            this.setState({ loading: false, error: true, tournament: null, leaderboard: [] });
        }
    }

    render() {
        const { loading, error, tournament, leaderboard } = this.state;

        if (loading) {
            return <div class="text-center p-10"><Trans>Loading tournament details...</Trans></div>;
        }

        if (error) {
            return <div class="text-center p-10 text-red-600"><Trans>Failed to load tournament data. Please try again later.</Trans></div>;
        }

        return (
            <div class="max-w-6xl mx-auto">
                <TournamentDetailsDisplay tournament={tournament} />
                <LeaderboardDisplay leaderboard={leaderboard} />
            </div>
        );
    }
}

// --- TournamentLeaderboardPage Class Component ---

interface TournamentLeaderboardPageProps {
    tournamentId: string; // From router
}

// No state needed for this simple wrapper
export class TournamentLeaderboardPage extends Component<TournamentLeaderboardPageProps, {}> {
    render() {
        const { tournamentId } = this.props;

        return (
            <FullSite>
                 <div class="p-4 md:p-8 bg-blue-whale-900 text-white min-h-screen">
                     <div class="mb-6">
                         {/* Keep the back link as it was */}
                         <a href="/slot-tournaments" class="text-blue-400 hover:text-blue-300">
                             &larr; <Trans>Back to Tournaments List</Trans>
                         </a>
                     </div>
                    <TournamentLeaderboardContent tournamentId={tournamentId} />
                </div>
            </FullSite>
        );
    }
}

// Export the Page component as default if needed by router, or keep named export
// export default TournamentLeaderboardPage; // Uncomment if router expects default export